import React, { useEffect, useState } from 'react';
import { ComponentBootstrap } from '@demant/react-bootstrap';
import flexSpotSchema from '@demant/react-bootstrap/lib/schemas/flex-spot-json';
import formPopUpFunction from './js/formPopUpFunction';
var CustomBannerReactComponent = function CustomBannerReactComponent(_ref) {
  var settings = _ref.settings,
    component = _ref.component;
  var element = settings.elements[0];
  var componentData = {
    imageLeft: element['image-left'] ? element['image-left'].image.src : element['image'] ? element['image'].image.src : null,
    imageRight: element['image-right'] ? element['image-right'].image.src : null,
    imageDevice: element['image-device'] ? element['image-device'].image.src : null,
    backgroundImage: element['background-image'] ? element['background-image'].image.src : null,
    contentHtml: element['banner-content'] ? element['banner-content'].html.html : element['bannerContent'] ? element['bannerContent'].html.html : null,
    link: element['link'] ? element['link'].link : null,
    showFor: element['show-for'] ? element['show-for'] : null,
    exceptFor: element['except-for'] ? element['except-for'] : null,
    customDelay: element['custom-delay'] ? element['custom-delay'].html.html : null,
    cookieName: 'closedPopupBaner'
  };
  useEffect(function () {
    var isSettingsNeeded = component.classList.contains('newsletter-banner');
    //check if settings needed- only for component above and if needed then find cookie and check exceptions
    /Firefox/i.test(navigator.userAgent) ? component.classList.add('firefox') : null;
    if (!isSettingsNeeded || settings && document.cookie.indexOf(componentData.cookieName) === -1 && exceptionItemFunction() && showOnlyForFunction()) {
      var customDelay = componentData.customDelay && componentData.customDelay.indexOf('delay') > -1 ? findCustomDelay(componentData.customDelay) : 5000;
      setTimeout(function () {
        setTimeout(function () {
          return component.classList.add('active-banner');
        }, 200);
        component.style.display = 'flex';
      }, customDelay);
    }
  }, []);
  var exceptionItemFunction = function exceptionItemFunction() {
    if (componentData.exceptFor) {
      return !findExceptions(componentData.exceptFor);
    } else {
      return true;
    }
  };
  var showOnlyForFunction = function showOnlyForFunction() {
    if (componentData.showFor) {
      return findExceptions(componentData.showFor);
    } else {
      return false;
    }
  };
  var findExceptions = function findExceptions(data) {
    var isException = false;
    if (Array.isArray(data)) {
      data.map(function (item) {
        if (window.location.href.indexOf(item.link.href) > -1) {
          isException = true;
        }
      });
    } else {
      isException = window.location.href.indexOf(data.link.href) > -1;
    }
    return isException;
  };
  var findCustomDelay = function findCustomDelay(delayString) {
    var delayIndex = delayString.indexOf('delay');
    var digit = delayString.slice(delayIndex, delayIndex + 10).replace(/\D+/g, '') + '000';
    return parseFloat(digit);
  };
  var isDataLayer = function isDataLayer() {
    return window.DGS && window.DGS.GTMTracking && window.DGS.GTMTracking.getDataLayer();
  };
  var closeHandler = function closeHandler() {
    if (isDataLayer()) {
      window.DGS.GTMTracking.getDataLayer().push(bannerEvent('click-close', 'close-banner'));
    }
    window.DGS.Cookies.getInstance().createCookie(componentData.cookieName, 'true', 30);
    component.classList.remove('active-banner');
    setTimeout(function () {
      component.style.display = 'none';
    }, 1000);
  };
  var bannerEvent = function bannerEvent(eventAction, eventLabel) {
    return {
      event: 'GAevent',
      eventCategory: 'custom-banner',
      eventAction: eventAction,
      eventLabel: eventLabel,
      eventCallback: function eventCallback() {
        if (eventAction === 'click-button') {
          window.open(componentData.link.href, componentData.link.target ? componentData.link.target : '_self');
        }
      }
    };
  };
  var linkToFunction = function linkToFunction($event, version) {
    window.DGS.Cookies.getInstance().createCookie(componentData.cookieName, 'true', 30);
    $event.preventDefault();
    if (isDataLayer()) {
      window.DGS.GTMTracking.getDataLayer().push(bannerEvent('click-button', version));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, componentData.contentHtml && /*#__PURE__*/React.createElement("div", {
    className: componentData.imageRight ? "flex-banner reverse" : "flex-banner",
    style: {
      backgroundImage: componentData.backgroundImageSrc ? componentData.backgroundImageSrc : ''
    }
  }, (componentData.imageRight || componentData.imageLeft || componentData.imageDevice) && /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__image ".concat(componentData.imageDevice ? 'image-device' : ''),
    style: {
      backgroundImage: "url('".concat(componentData.imageLeft ? componentData.imageLeft : componentData.imageRight || componentData.imageDevice, "')")
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(componentData.imageLeft ? componentData.imageLeft : componentData.imageRight || componentData.imageDevice)
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: componentData.contentHtml
    }
  }), componentData.link && /*#__PURE__*/React.createElement(ButtonsAbTest, {
    linkTo: componentData.link,
    linkToFunction: linkToFunction
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__close",
    onClick: closeHandler
  }, "\uEAE3")));
};
var ButtonsAbTest = function ButtonsAbTest(_ref2) {
  var linkTo = _ref2.linkTo,
    linkToFunction = _ref2.linkToFunction;
  return /*#__PURE__*/React.createElement("div", {
    className: "test-ab"
  }, /*#__PURE__*/React.createElement("a", {
    href: linkTo.href,
    className: "pep-button bg-m-magenta a-version",
    onClick: function onClick(e) {
      return linkToFunction(e, linkTo, 'a-version');
    }
  }, linkTo.content), /*#__PURE__*/React.createElement("a", {
    href: linkTo.href,
    className: "button b-version",
    onClick: function onClick(e) {
      return linkToFunction(e, linkTo, 'b-version');
    }
  }, linkTo.content));
};
var c = new ComponentBootstrap('.flex-spot.custom-banner:not(.embed-form-banner)');
c.schemaData = flexSpotSchema;
c.reactApp = CustomBannerReactComponent;
setTimeout(function () {
  return c.run();
}, 0);
if (document.querySelector('.flex-spot.custom-banner.embed-form-banner')) {
  formPopUpFunction(document.querySelector('.embed-form-banner'));
}